'use strict';

import React, { Component } from 'react';

import NewRouteur from './configModule/routeurManagement.jsx';

class Card extends Component{
    state = {
            //Initiate Default User
            popupStateRouteur: "overlay hidden",
        }
    closeOverlay= () => {
        this.setState({popupStateRouteur: "overlay hidden",
        });
    }
    newRouteur= (e) => {
        e.preventDefault();
        this.setState({popupStateRouteur: "overlay"});
    }
    componentDidMount() {
    }
    componentWillUnmount() {
        try {

        } catch (e) {
            console.log(e);
        }
    }
    render() {
        return (
            <div className="container">
                <div className="col-md-4 col-sm-6">
                    <div className="card">
                        <div className="card-header bgm-lightgreen">
                            <h2>Routeur
                                <small></small>
                            </h2>
                        </div>

                        <div className="card-body card-padding">
                          {/*<p onClick={this.listInfo} id="/installer/list" data-nameinfo="Installateur" data-subname="Liste">Nombre installateur: {this.state.NumberOfInstallater}</p>
                          */}  <button className="btn btn-primary" onClick={this.newRouteur}>Connect Routeur</button>
                        </div>
                    </div>
                </div>
               
                <NewRouteur popupState={this.state.popupStateRouteur} onCloseOverlay={this.closeOverlay}/>
        </div>
        );
    }
};
export default Card;

